import React, { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next'
import Host from "../Host";
import { useForm } from "react-hook-form";
import { Modal } from 'react-bootstrap'
import Button from '@mui/joy/Button';
import IconButton from '@mui/joy/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from "react-redux";
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import Countries from '../Header/Countries';
import { useCreateShippingAddressMutation } from '../../services/login';
// import ShippingCountry from '../../Helpers/ShippingCountry';

function ShippingAddressModal({ isModal, closeShippingAddressModal, isUpdateData }) {
  const { userId, userToken, userEmail, userName, languageCode, countryCode, cartToken, guestShippment, guestPayment, isPurchase } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const { register, handleSubmit, setValue, watch, formState: { errors }, reset, } = useForm({
    defaultValues: {
      name: "",
      email: "",
      address: "",
      street: "",
      city_code: "",
      city: "",
      country: "",
      country_code: "",
      zip_code: "",
      phone: "",
    }
  });

  const selectedCityCode = watch("city_code");
  const { t } = useTranslation()


  const findCurrentCountry = Countries?.find((l) => l.code == countryCode)

  // const shippingInfo = ShippingCountry?.filter((l) => l.country_code == countryCode)
  // const cityName = shippingInfo?.find((l) => l.city_code == selectedCityCode)

  const [getPhone, setPhone] = useState('')
  const [getPhoneError, setPhoneError] = useState(false)

  const [createshipping, createresult] = useCreateShippingAddressMutation()

  const [getUpdateId, setUpdateId] = useState();
  const [isModalType, setModalType] = useState('')
  useEffect(() => {
    if (isUpdateData) {
      setValue("name", isUpdateData?.name || "");
      setValue("email", isUpdateData?.email || "");
      setValue("address", isUpdateData?.address || "");
      setValue("street", isUpdateData?.street || "");
      setValue("city", isUpdateData?.city || "");
      setValue("short_address", isUpdateData?.short_address || "");
      setValue("zip_code", isUpdateData?.zip_code || "");
      setPhone(isUpdateData?.phone);
      setModalType(isUpdateData?.type);
      setUpdateId(isUpdateData?.id);
    }
  }, [isUpdateData, setValue]);

  const createshippingaddress = (data) => {
    if (isValidPhoneNumber(getPhone)) {
      const updated = {
        userToken: userToken,
        userId: userId,
        phone: getPhone,
        countryCode: countryCode,
        country: findCurrentCountry?.label,
        country_code: findCurrentCountry?.code,
        email: userEmail,
        type: isModalType
      };
      if (getUpdateId) {
        createshipping({
          id: getUpdateId,
          ...data,
          ...updated,
        });
      } else {
        createshipping({
          ...data,
          ...updated,
        });
      }
    } else {
      setPhoneError(true)
    }
  };

  useEffect(() => {
    if (createresult?.isSuccess) {
      closeShippingAddressModal()
      reset()
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, [createresult?.isSuccess])

  return (

    <Modal className="shipping-address-modal" show={isModal} onHide={closeShippingAddressModal} centered animation={false}>
      <Modal.Header>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          <div style={{ fontWeight: 500, fontSize: '1.1rem' }}>
            Add new shipping address
          </div>
          <IconButton
            variant='outlined'
            size='sm'
            color='danger'
            style={{ minHeight: '27px', maxHeight: '27px' }}
            onClick={closeShippingAddressModal}
          >
            <CloseIcon className="Header-close-modal-icon" style={{ fontSize: '1.2rem' }} />
          </IconButton>
        </div>
      </Modal.Header>
      <Modal.Body>
        {createresult?.error?.data?.error &&
          <div style={{ paddingTop: 20 }}>
            <div style={{ textAlign: 'center', color: '#ea8087' }}>{createresult?.error?.data?.error}</div>
          </div>
        }
        <form onSubmit={handleSubmit(createshippingaddress)}>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group" style={{marginBottom: '0.7rem'}}>
                <label style={{ fontSize: '14px', fontWeight: 500 }}>{t('name')} </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  aria-invalid={errors.name ? "true" : "false"}
                  {...register('name', { required: true })} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group" style={{marginBottom: '0.7rem'}}>
                <label style={{ fontSize: '14px', fontWeight: 500 }}>{t('address_flat')} </label>
                <input
                  type="text"
                  className="form-control"
                  id="address"
                  aria-invalid={errors.address ? "true" : "false"}
                  {...register('address', { required: true })} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group" style={{marginBottom: '0.7rem'}}>
                <label style={{ fontSize: '14px', fontWeight: 500 }}>{t('street_area')} </label>
                <input
                  type="text"
                  className="form-control"
                  id="street"
                  aria-invalid={errors.street ? "true" : "false"}
                  {...register('street', { required: true })} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group" style={{marginBottom: '0.7rem'}}>
                <label style={{ fontSize: '14px', fontWeight: 500 }}>{t('city')} </label>
                <input
                  type="text"
                  className="form-control"
                  id="city"
                  aria-invalid={errors.city ? "true" : "false"}
                  {...register('city', { required: true })} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group" style={{marginBottom: '0.7rem'}}>
                <label style={{ fontSize: '14px', fontWeight: 500 }}>{t('country')} </label>
                <select className="form-control">
                  <option disabled selected>{findCurrentCountry?.label}</option>
                </select>
              </div>
            </div>
            {countryCode === 'SA' &&
              <div className="col-md-12">
                <div className="form-group" style={{marginBottom: '0.7rem'}}>
                  <label style={{ fontSize: '14px', fontWeight: 500 }}>{t('Short National Address')} </label>
                  <input
                    defaultValue={guestShippment?.short_address}
                    type="text"
                    className="form-control"
                    id="short_address"
                    aria-invalid={errors.short_address ? "true" : "false"}
                    {...register('short_address', { required: true })} />
                </div>
              </div>
            }
            <div className="col-md-6">
              <div className="form-group" style={{marginBottom: '0.7rem'}}>
                <label style={{ fontSize: '14px', fontWeight: 500 }}>{t('phone')} </label>
                <PhoneInput
                  international
                  countryCallingCodeEditable={false}
                  defaultCountry={countryCode}
                  value={getPhone}
                  onChange={setPhone}
                />
                {getPhoneError &&
                  <>
                    {getPhone && isValidPhoneNumber(getPhone) ? '' :
                      <div><small style={{ color: 'tomato' }}>{'Invalid phone number'}</small></div>
                    }
                  </>
                }
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group" style={{marginBottom: '0.7rem'}}>
                <label style={{ fontSize: '14px', fontWeight: 500 }}>{t('zip_code')} </label>
                <input
                  type="text"
                  className="form-control"
                  id="zip_code"
                  aria-invalid={errors.zip_code ? "true" : "false"}
                  {...register('zip_code', { required: false })} />
              </div>
            </div>
            <div className="col-md-12 Header-signin-button">
              <div className="form-group">
                <Button
                  disabled={createresult.isLoading}
                  style={{ background: Host?.bgColor, color: Host?.buttonColor, width: '100%', height: '45px' }}
                  type="submit">
                  {createresult.isLoading ? t('loading') : t('submit')}
                </Button>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default ShippingAddressModal;
